export type ContentItem = {
  readonly type: "clause" | "list_item" | "table";
  readonly text: string;
  readonly textAsHtml?: string;
  readonly createdAt?: string;
};

/** Decision classification stored on each approved section version (API: content_risk_level). */
export type ContentRiskLevel =
  | "ExecDecision"
  | "BusinessDecision"
  | "LegalDecision";

export const CONTENT_RISK_LEVELS: readonly ContentRiskLevel[] = [
  "ExecDecision",
  "BusinessDecision",
  "LegalDecision",
];

const LEGACY_CONTENT_RISK: Record<string, ContentRiskLevel> = {
  green: "ExecDecision",
  amber: "BusinessDecision",
  red: "LegalDecision",
};

/** Parse API or legacy traffic-light values into the canonical decision label. */
export function parseContentRiskLevel(raw: string | undefined): ContentRiskLevel {
  if (!raw) return "BusinessDecision";
  if (
    raw === "ExecDecision" ||
    raw === "BusinessDecision" ||
    raw === "LegalDecision"
  ) {
    return raw;
  }
  const mapped = LEGACY_CONTENT_RISK[raw.toLowerCase()];
  return mapped ?? "BusinessDecision";
}

export type Section = {
  readonly sectionName: string;
  readonly businessUnit: string[];
  readonly content: ContentItem[];
  readonly activeVersion?: string;
  /** contract_sections.approval_status from API (e.g. Pending, Approved). */
  readonly approvalStatus?: string;
  /** From approved_sections.content_risk_level when viewing an approved snapshot. */
  readonly contentRiskLevel?: ContentRiskLevel;
};

export type ContractTemplate = {
  readonly contractName: string;
  readonly contractType: string;
  readonly contractReviewer: string;
  readonly contractOrigination: string;
  readonly effectiveDate: string;
  readonly sections: Section[];
};

export type VersionEntry = {
  readonly version: string;
  readonly modifiedBy: string;
  readonly date: string;
};
